export default __webpack_public_path__ + "static/954-37178aff88215de178a11d0b4ecdc3f2.mp4";